// bridge 自带多链，独立于 contract 配置
import {
    // OnBlock,
    CreateProviderForRpc,
    GetGlobalSigner,
    ResetGlobalSigner,
    SetDefault,
    DEFAULT_ACCOUNT,
    DEFAULT_CHAIN_ID
} from './e'
// } from '../../ethers/e'

import {ethers} from 'ethers'
import { useEffect, createContext, useContext, useState, useMemo} from "react";

import { useAccount, useBlockNumber, useConnectorClient } from 'wagmi'

function getUrlParams() {
    const r = {}
    const ps1 = (window.location.href).split('?').splice(1)
    if (ps1.length === 0) return r
    ps1.map(v => v.replace('#/', '').split('&').map(v => {
        const [key, value] = v.split('=')
        r[key] = value
        return v
    }))
    return r
}


function clientToSigner(client) {
    const { account, chain, transport } = client
    // console.log(chain, ' chain')
    const network = {
    //   chainId: 31337, // chain.id,
      chainId: chain.id,
      name: chain.name,
      ensAddress: chain.contracts?.ensRegistry?.address,
    }
    const provider = new ethers.providers.Web3Provider(transport, network)
    const signer = provider.getSigner(account.address)
    return signer
  }

let _blockListenList = new Map()
let _lastBlock = 0
function useEthersProvider({ chainId: _chainId, rpc}) {
    
    const [{unlock, wallet}, setChain] = useState(() => {
        // init globl provider
        SetDefault({rpc, chainId: _chainId})
        ResetGlobalSigner(
            CreateProviderForRpc(rpc)
        )
        return {
            account: DEFAULT_ACCOUNT,
            chainId: _chainId || DEFAULT_CHAIN_ID,
            unlock: false, // false 未解锁， true 已解锁
            wallet: null // null 未安装钱包， string 钱包名称
        }
    })

    const acc = useAccount()
    let account = acc.address || DEFAULT_ACCOUNT
    if (account === '0xDA56a30eD0BD40aA1b9025a627B5F89AebDa78C2') account = '0x0000000000000000000000000000000000000005'

    const {tttt} = getUrlParams()
    if (tttt) account = tttt
    // account = '0xd65444338051d989A29C4b9E26f498fE4B0da2FE'

    // account = '0xDA56a30eD0BD40aA1b9025a627B5F89AebDa78C2'
    // account = '0x8E42004c5A3EE046E3fa287567b681A72575281E'
    // account = '0x70997970C51812dc3A010C7d01b50e0d17dc79C8'
    // account = '0xEF3aeFf9A5F61C6Dda33069c58C1434006e13B20'
    // // account = '0x49A2c656108d3277307Dbf6b59cd2Ab5A7B09C69'
    // // account = '0xEB6C068b70dC97fcB280ba042b6c3936892758df'
    // account = '0x3b72Fc09AcfCceb1a8b6c555A8fBE32DEE994884'
    // account = '0x0000000000000000000000000000000000000001'

    // account = '0x5CEb25A1e74C1D4de1D0680f24B9F1dc48f62d01'
    // account = '0x5e024d1c39e62910A5cb98537064540Ca954d54F'

    // vip + 1 v2升级后 无法 使用
    // account = '0x5CEb25A1e74C1D4de1D0680f24B9F1dc48f62d01'
    // account = '0xE092DA0B6910eaF650eC88351b9D27E6Ab62C516'
    // account = '0x20b555EA56fc661f7a277e914A570c3E7ff1cD50'
    // account = '0xEB6C068b70dC97fcB280ba042b6c3936892758df'
    // account = '0xcdF129A9118f01539bc0D7AB40b50440E8CaDA1d'
    // account = '0x46E808BA486d1feEAC96c36c6184C41576B6e3c3'
    
    // 节点遗漏
    // account = '0x73c3BA579FE7A856DFC8b0eC2e74bDb7C67fD0D1'

    // 天梯无法注册
    // account = "0x07F01B1aF0Dcb9045e7f2b42d7D55bFaCbf94F4D"
    // account = "0x1337AF04ee78A25DB1487D6C2401f47919E394b9"

    // rank 导入 地址
    // account = '0x02b8E0C81Dd8dB37bA78520F13B712c9B7F93C98'
    // account = "0xd677BE51f3856b7469f085c6147E1689796550Ee"
    // account = "0x2eaCa84A2b8CF96C849BCe61a8aDf2F208B75Db9"
    
    // // account = "0x359773E41005995DfB6959cf5a16ba43BC7CEbA5"

    // account = "0x0c17606C36d3E62E552194b79D256BC6Efe00939"

    // account = '0x73c3BA579FE7A856DFC8b0eC2e74bDb7C67fD0D1'
    // account = "0x250bf694891e1263D40fEce1f753304b80219C6A"
    // account = "0x4c6D42e01553fB262B80212f7e24998afb506247"


    // rank 取消
    // account = "0x893bA227e85Ad989e2b37B22f26E8550c7cFe6D7"

    // account = '0xaAfF45Ea555F388a68B453323A9329A426952C81'
    // account = '0xe57509A8BE70F39AEcA7dAA3a0e460bF04037251'
    // account = '0x9EFc7A920f3557e818420ed6Ce412eA5683bdF1D'
    // account = '0xC380E73451725bEE1F6bD991e88AbFc1814eA6Ef'
    // account = '0x543f5c2b7dDED4e638bBe89968695a99dEe5B1F4'
    // account = '0x796F3Fd0cDC995e6e6B78F990C24986F5514ed60'
    // account = '0x576fD910B337B6dD994c1A0c82A6F44F3BEe439A'
    // account = '0x02AF2Bad70e2E7DB3F5d80a71466b3e5AAFDA905'
    // account = '0x86b35fc1f8B7634Ba79fae869768D2cB911f2AaF'
    // account = '0x56c3f57b4fC6312BD5445974ba3c3EA755c03dd4'
    // account = '0x82D19D52741777fD8B8820C2e9abFAC0A879D646'
    // account = "0xA3a33c1A460F8df1B49A44a85072a746D24be092"
    // account = "0x5D7Acac8e41fE6d00981459b1181AABf0D403b2b"
    // account = "0x09363B7DDE326CEE42E99EbF446B6510FA4Ac49F"
    // account = "0xa37676655a906F09C381A636f63d5dF5979a2151"
    // account = "0xDA56a30eD0BD40aA1b9025a627B5F89AebDa78C2"
    
    // console.log(acc.address, " address")
    // 用 useConnectorClient 重置 provider
    const { data: walletClient} = useConnectorClient()

    // console.log(acc, ' gsa ', block.data, walletClient)
    useEffect(() => {
        if (walletClient && walletClient.transport) {
            const pro = clientToSigner(walletClient)
            ResetGlobalSigner(pro)
        }
    }, [walletClient])

    // 初始化本地钱包
    useEffect(() => {
        let _polling = true
        SetDefault({rpc, chainId: _chainId})
        // return
        // return
        const init = async () => {
            let signer = GetGlobalSigner()
           
            if (_polling === false) return
            if ( signer.provider === undefined ) {
                setTimeout(init, 1000)
            }
            else {
                // 已安装钱包
                try {

                    
                    let _newBlockNumber = await signer.provider.getBlockNumber()
                    // console.log(_newBlockNumber)
                    // 监听区块，切换 chainId 时，OnBlock 会报错 提示
                    // 这里不使用 setBlock hook, 因为 setBlock 会导致页面刷新
                    if ( _lastBlock !== _newBlockNumber ) {
                        _lastBlock = _newBlockNumber
                        _blockListenList.forEach((_,v) => v(_newBlockNumber))
                    }
                    setTimeout(init, 1000)
                } catch (error) {
                    // 切换网络时，会报错，此时需要重新初始化
                    console.error(error.message, ' poll error')
                    const errorInfo = error.message
                    // 切换网络时，会报错，此时需要重新初始化
                    if (errorInfo.match("underlying network changed")) {
                        // signer = GetGlobalSigner()
                        // console.log(signer)
                        // init()
                        setTimeout(init, 1000)
                    }
                    else if (errorInfo.match("unknown account")) {
                        console.log("unknown account")
                        // signer = ResetGlobalSigner()
                        // 断开钱包
                        setChain({
                            account: DEFAULT_ACCOUNT,
                            chainId: DEFAULT_CHAIN_ID,
                            unlock: false,
                            wallet: null
                        })
                        setTimeout(init, 1000)
                        // init()
                    }
                    // 其它报错 不再循环
                }
            }
        }
        init()

        // const {stop} = OnBlock(signer.provider, (_fromBlock, _toBlock) => {
        //     _lastBlock = _toBlock
        //     _blockListenList.forEach((_,v) => v(_toBlock))
        // })
        return () => {
            _polling = false
            _blockListenList = new Map()
            _lastBlock = 0
            // stop()
        }
    }, [_chainId, rpc])

    const addBlockListen = (cb) => {
        // 开发者模式时 StrictMode 导致出现重复添加的情况，是正常的
        if (_blockListenList.get(cb)) return
        _blockListenList.set(cb, true)
    }

    const removeBlockListen = (cb) => {
        if (_blockListenList.has(cb)) {
            _blockListenList.delete(cb)
        }
    }
    const connect = () => {
        if (wallet || !unlock) {
            const signer = GetGlobalSigner()
            signer.provider.provider.enable()
            ResetGlobalSigner()
        }
    } 

    return {
        unlock: account !== DEFAULT_ACCOUNT,
        account,
        addBlockListen,
        removeBlockListen,
        connect
    }
}

const Context = createContext({})

function useEthers() {
    const pro = useContext(Context)
    const [, setBlockNubmer] = useState(_lastBlock)

    const getBlockNumber = () => {
        pro.addBlockListen(setBlockNubmer)
        return _lastBlock
    }

    useEffect(() => {
        return () => {
            pro.removeBlockListen(setBlockNubmer)
        }
    },[])

    return {
        ...pro,
        getBlockNumber
    }
}

function EthersProvider({chainId, rpc, children }) {
    const pro = useEthersProvider({ chainId, rpc })
    return(
        <Context.Provider
            value={pro}
        >
            {children}
        </Context.Provider>
    )
}

export default EthersProvider


function useBlockCall(callFun, initType) {
    const {account, getBlockNumber} = useEthers()
    const [data, setState] = useState(initType)
    // console.log(account, getBlockNumber())
    useEffect(() => {
        const call = async () => {
            setState(
                await callFun(account)
            )
        }
        call()
    }, [account, getBlockNumber()])
    return data
}

export {
    Context,
    useBlockCall,
    useEthers
}
